import helpers from 'helpers'

const defineSubtitle = (trail) => {
  if (trail.completed) {
    return helpers.formatters.dateLocaleFormat(
      trail.updatedAt,
      'DD/MM/YYYY - HH:mm',
    )
  }

  return '-'
}

export default defineSubtitle
